
import { KioskSetting } from "../models/kiosk";

export class KioskSettingTypeFilterValueConverter {
    toView(settings: KioskSetting[], type: string) {
        if (settings === undefined || settings === null) return settings;
        if (type === "" || type === undefined) return settings;

        return settings.filter((item) => item.type === type);
    }
}